import React from "react";
import { useQuery } from "@apollo/react-hooks";

import Layout from "components/Layout";
import DataTable, { mapData } from "components/DataTable";
import BarChart from "components/chart/BarChart";
import withAuth from "components/withAuth";
import Scrollable from "components/Scrollable";
import { H2, Section } from "styles";
import { YEAR } from "queries";

function Year() {
  const { data: { years } = { years: [] } } = useQuery(YEAR);

  const data = mapData(years);

  return (
    <Layout>
      <Section>
        <H2>Contacts by Year</H2>
        <DataTable
          headers={["", "Year", "Count"]}
          data={data}
          link="/contact/year/"
        />
      </Section>
      <Section>
        <H2>Bar Chart</H2>
        <Scrollable>
          <BarChart data={data} />
        </Scrollable>
      </Section>
    </Layout>
  );
}

export default withAuth(Year);
